export const mentionHref = (username) => {
  const mentionUrl = process.env.REACT_APP_BASE_URL_OLD + '/business/';

  return `href="${
    mentionUrl + encodeURIComponent(username)
  }" target="_blank" rel="noopener noreferrer"`;
};
